/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
function o(o,t,f,r,l){const e=Math.floor(r/2);for(let c=0;c<e;c++)for(let r=0;r<t;r++)o[c*t+r]=o[(l-1-c)*t+r],o[(f-1-c)*t+r]=o[(f-l+c)*t+r];const n=Math.floor(l/2);for(let c=0;c<f;c++){const f=c*t;for(let r=0;r<n;r++)o[f+r]=o[f+l-1-r],o[f+t-r-1]=o[f+t+r-l]}}export{o as mirror};
